import React, { FC } from "react";
import { Link } from "react-router-dom";
import { setClass } from "../../utils";
import { ILinks } from "./Tabs";
import '../../styles/components/tabs.scss'

interface TabLinkProps {
  link: ILinks;
  active?: boolean;
}

export const TabLink: FC<TabLinkProps> = ({ link, active }) => (
  <Link to={link.route} className={setClass('tab-link', active && 'active')}>
    {link.title}
  </Link>
);
